import { render, staticRenderFns } from "./GitlabWorkspaceModal.vue?vue&type=template&id=94dfdc68&"
import script from "./GitlabWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./GitlabWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabWorkspaceModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GitlabWorkspaceModal.vue
// module id = 2196
// module chunks = 1